import { Box } from "@mui/material";

export const MembershipsPageSkeleton = () => {
    return <Box className="skeleton" role="status" aria-label="loading" />;
};
export default MembershipsPageSkeleton;
